import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import ChatSection from './components/ChatSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <main>
          <Routes>
            <Route path="/" element={<ChatSection />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;